import { render } from "./Susie.vue?vue&type=template&id=505cf784"
import script from "./Susie.vue?vue&type=script&lang=js"
export * from "./Susie.vue?vue&type=script&lang=js"

import "./Susie.vue?vue&type=style&index=0&id=505cf784&lang=css"

import exportComponent from "D:\\TeamCity\\BuildAgent2\\work\\1bfd74eb4d5fb108\\FamilyPortalApp\\familyportal-app\\src\\familyportal-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__